import { getVideoList, getCountry, searchVideoList } from '@/utils/api.js'

export const getVideos = async({ commit }, [searchCategory, searchLabel, page, limit, completed]) => {
    let country = await getCountry()
    getVideoList(searchCategory, searchLabel, page, limit).then(res => {
        commit('ADD_VIDEOS', [res.data, country.data])
    }).catch(e => {
        // console.log(e)
    }).finally(() => {
        if (completed && typeof completed === 'function') completed()
    })
}

export const searchVideos = async({ commit }, [searchKeyWords, page, limit, completed]) => {
    let country = await getCountry()
    searchVideoList(searchKeyWords, page, limit).then(res => {
        commit('ADD_VIDEOS', [res.data, country.data])
    }).catch(e => {
        console.log(e)
    }).finally(() => {
        if (completed && typeof completed === 'function') completed()
    })
}

export const updateVideo = async({ commit }, video) => {
    let country = await getCountry()
    commit('ADD_VIDEOS', [[video], country.data])
}

export const swapVideosInList = ({ commit }, [videoIndex1, videoIndex2]) => {
    commit('SWAP_VIDEOS_IN_LIST', [videoIndex1, videoIndex2])
}

export const clearVideos = ({ commit }) => {
    commit('SET_VIDEO_DICT', {})
}

export const selectVideo = ({ commit }, video) => {
    commit('SET_CURRENT_SELECT_VIDEO', video)
}

export const setSharingVideoURL = ({ commit }, url) => {
    commit('SET_SHARING_VIDEO_URL', url)
}

export const setGivePetalVideo = ({ commit }, video) => {
    commit('SET_GIVE_PETAL_VIDEO', video)
}

export const setCountryData = ({ commit }, lang) => {
    commit('SET_COUNTRY_DATA', lang)
}

export const setUserInfo = ({ commit }, userInfo) => {
    commit('SET_USER_INFO', userInfo)
    if (userInfo) {
        commit('SET_USER_BALANCE', userInfo.balance)
    }
}

export const closePoster = ({ commit }) => {
    commit('CLOSE_POSTER')
}

export const setUserBalance = ({ commit }, balance) => {
    commit('SET_USER_BALANCE', balance)
}

export const setUserNextRewardTime = ({ commit }, timestamp) => {
    commit('SET_USER_NEXT_REWARD_TS', timestamp)
}

export const setActivePoint = ({ commit }, ap) => {
    commit('SET_ACTIVE_POINT', ap)
}

export const addActivePoint = ({ commit }, ap) => {
    commit('ADD_ACTIVE_POINT', ap)
}

export const setSharedVideoCount = ({ commit }, num) => {
    commit('SET_SHARED_VIDEO_COUNT', num)
}

export const setLanguageSearchLabel = ({ commit }, language) => {
    commit('SET_LANGUAGE_SEARCH_LABEL', language)
}

export const setLanguageSearchSubtitleLabel = ({ commit }, language) => {
    commit('SET_LANGUAGE_SEARCH_SUBTITLE_LABEL', language)
}

export const setCategorySearchLabel = ({ commit }, category) => {
    commit('SET_CATEGORY_SEARCH_LABEL', category)
}

export const setSubCategorySearchLabel = ({ commit }, subcategory) => {
    commit('SET_SUBCATEGORY_SEARCH_LABEL', subcategory)
}

export const setIsPcClient = ({ commit }, res) => {
    commit('SET_IS_PC_CLIENT', res)
}



// WEBPACK FOOTER //
// ./src/store/actions.js